module.exports = new __parcel__URL__("galery_theme.6092c90c.mp3").toString();